import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useApi } from '@/api/ApiContext';
import type { JournalListQuery } from '@/api/handlers/resources/journal/requests';
import type { JournalEntryListResponse } from '@/api/handlers/resources/journal/responses';
import type { ApiResponse } from '@/api/handlers/responses';
import { JournalQueryKeys } from './journalQueryKeys';

const STALE_TIME_MS = 30_000;

/**
 * Paged, filtered journal list. `keepPreviousData` holds the current page on
 * screen while the next loads (no flash). Never rejects — read `data.success`.
 */
export const useJournalEntriesQuery = (
    query: JournalListQuery,
    enabled = true,
) => {
    const { apiClient } = useApi();

    return useQuery<ApiResponse<JournalEntryListResponse>>({
        queryKey: JournalQueryKeys.list(query),
        queryFn: () => apiClient.journal.listEntries(query),
        enabled,
        staleTime: STALE_TIME_MS,
        placeholderData: keepPreviousData,
    });
};
